var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPrint = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 36,
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 35,
  height: 35,
  rx: 17.5,
  stroke: "#CCCCCC"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 15V8H24V15",
  stroke: "black",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 24H10C9.46957 24 8.96086 23.7893 8.58579 23.4142C8.21071 23.0391 8 22.5304 8 22V17C8 16.4696 8.21071 15.9609 8.58579 15.5858C8.96086 15.2107 9.46957 15 10 15H26C26.5304 15 27.0391 15.2107 27.4142 15.5858C27.7893 15.9609 28 16.4696 28 17V22C28 22.5304 27.7893 23.0391 27.4142 23.4142C27.0391 23.7893 26.5304 24 26 24H24",
  stroke: "black",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M24 20H12V28H24V20Z",
  stroke: "black",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgIconPrint;